import { isAfter } from 'date-fns'
import {
    createVehicle,
    IVehicleFactory,
    Vehicle,
} from '../../entities/vehicle/Vehicle'
import { api, Api } from '../../services/api'
import {
    IVehicleResponse,
    transformVehicle,
} from '../../transformers/vehicle/VehicleTransformer'
import { IVehicleDataHandler } from './IVehicleDataHandler'

export class VehicleDataHandler implements IVehicleDataHandler {
    api: Api

    constructor() {
        this.api = api
    }

    async getVehicles(): Promise<Vehicle[]> {
        const { data } = await this.api.client.get('sra_dashboard_columns_eta')

        // const testData: {
        //     vehicle: IVehicleResponse[]
        // } = {
        //     vehicle: [
        //         {
        //             // driver_id: '072a9a78-7be3-444d-994b-e5bee75a2a23',
        //             driver_name: 'elad kantor',
        //             eta: {
        //                 actual_eta: '03/05/2025 13:00',
        //                 // original_eta: '06/05/2022 14:00',
        //             },
        //             // order_id: '668e9d69-84db-421b-a131-863558e70cf8',
        //             // route_id: '5b9cfd37-d79b-4db1-99b4-368ad80fe80c-20220506',
        //             tracking: {
        //                 geolocation: '32.175296 34.908773',
        //                 // tracking_link: null,
        //             },
        //             vehicle_id: '5b9cfd37-d79b-4db1-99b4-368ad80fe80c',
        //             arrival_in: 420,
        //             show_vehicle_notification: true,
        //             vendor_store_info: {
        //                 lat: '32.175296',
        //                 lng: '34.908773',
        //             },
        //             // vehicle_type: 'van',
        //         },
        //     ],
        // }

        const transformedVehicles: IVehicleFactory[] =
            data.vehicle.map(transformVehicle)
        // console.log(transformedVehicles)

        return transformedVehicles
            .filter((vehicle) => vehicle.shouldShow)
            .filter((vehicle) => isAfter(vehicle.arrivesAt, new Date()))
            .map(createVehicle)
            .sort(
                (vehicleA, vehicleB) => vehicleA.arrivesIn - vehicleB.arrivesIn
            )
    }
}
